import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import * as d3 from "d3";
import * as crossfilter from "crossfilter2/crossfilter";
import "dc/dist/style/dc.css";
export const CXContext = React.createContext("CXContext");

const DataContext = (props) => {
  const ref = useRef();
  const [loading, setLoading] = useState(false);

  const [hasNDX, sethasNDX] = useState(false);
  const [hasCountyShapefile, setHasCountyShapefile] = useState(false);
  const [ndx, setndx] = useState();
  const [county, setCountyData] = useState();

  
 
  useEffect(() => {
    //setLoading(true);
    axios.get("/Home/QueryCountyBoundary").then((res) => {
      setCountyData(res.data);
      setHasCountyShapefile(true);
    });

    axios
      .get("/Home/getAggregatedData")
      .then((res) => {
        let data = res.data;
        // console.log(data);
        var dateFormatSpecifier = "%m/%d/%Y";
        var dateFormatParser = d3.timeParse(dateFormatSpecifier);

        data.forEach(function (e) {
          e.dd = dateFormatParser(e.month);

          e.month = d3.timeMonth(e.dd); // pre-calculate month for better performance
        });
        setndx(crossfilter(data));
        sethasNDX(true);
        setLoading(false);
      })
      .then(() => {
        const loader = document.querySelector(".preloader");
        if (loader) {
          loader.classList.add("after-loader");
        }
      });
  }, []);
  if (!hasNDX) {
    return null;
  }
  if (!hasCountyShapefile) {
    return null;
  }
  return (
    <CXContext.Provider value={{ ndx: ndx, boundary: county }}>
      <div ref={ref.current}>{props.children}</div>
    </CXContext.Provider>
  );
};
export default DataContext;
